import { assert } from '@fe/core';
import { weatherDisposeWorker } from '@fe/weather';
import React from 'react';
import { LoadingIndicatorLinear } from '../components/indicators/LoadingIndicatorLinear';
import { useAuthProvider } from '../contexts/AuthProvider';
import { useAppDispatch, useAppSelector } from '../hooks/store-hooks';
import { useSafeEffect } from '../hooks/use-safe-effect';
import { resetApp, startSyncLoop, stopSyncLoop } from '../state/slices';
import { setAuthenticatedUser, setCompanyFeaturesEnabled } from '../state/slices/user-slice';

// This component sits on top of the application frame. It provides all the things that need to happen at startup e.g. running flight-worker, backend sync etc.
export default function ApplicationBootstrap(props: { children?: React.ReactNode }) {
    const firstSyncCompleted = useAppSelector((x) => x.global.firstSyncCompleted);
    const auth = useAuthProvider();
    const dispatch = useAppDispatch();

    useSafeEffect(() => {
        return () => weatherDisposeWorker();
    }, []);

    useSafeEffect(() => {
        if (!auth.initialized) {
            return;
        }

        const account = auth.account;
        assert(account);
        dispatch(setAuthenticatedUser({ username: account.userId }));
        dispatch(setCompanyFeaturesEnabled(!!account.dmGroupId.trim()));
        dispatch(startSyncLoop());

        return () => {
            dispatch(stopSyncLoop());
            // This needs set timeout 0 because of the order of which destructors are executed in react
            self.setTimeout(() => dispatch(resetApp()), 0);
        };
    }, [auth.initialized]);

    if (!firstSyncCompleted) {
        return (
            <>
                <LoadingIndicatorLinear />
                {import.meta.env.DEV && <div>Loading settings...</div>}
            </>
        );
    }

    return props.children;
}
